// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3vUMn","list":"PatternAutocomplete_list__2HN16"};